export const cookie = {
  title: 'Cookie Policy',
  lastUpdated: 'Last updated: January 2025',
  
  intro: {
    title: 'Introduction',
    text: 'This Cookie Policy explains how NovaVenture Group BV ("we", "us", "our") uses cookies and similar technologies on our website. By using our website, you agree to the use of cookies as described in this policy.'
  },

  whatAreCookies: {
    title: 'What are cookies?',
    text: 'Cookies are small text files that are placed on your device (computer, tablet or smartphone) when you visit a website. Cookies help websites remember your preferences and improve the functionality of the website.'
  },

  cookiesWeUse: {
    title: 'Which cookies do we use?',
    intro: 'Currently, NovaVenture Group BV only uses strictly necessary functional cookies. We do not use tracking, analytics or marketing cookies.',
    
    necessary: {
      title: 'Strictly necessary cookies',
      description: 'These cookies are essential for the proper functioning of our website. Without these cookies, the website cannot function properly. These cookies do not collect personal information and cannot be disabled.',
      examplesLabel: 'Examples:',
      examples: 'Session cookies, language preference, security cookies'
    },

    noTracking: {
      title: 'No tracking or marketing cookies',
      description: 'We currently do not use cookies for tracking, analytics or marketing purposes. Your browsing behavior is not tracked and no profiles are created about you.'
    }
  },

  futureTracking: {
    title: 'Future use of tracking cookies',
    text: 'Should we decide to use tracking, analytics or marketing cookies in the future, we will ask for your explicit consent in advance via a cookie banner. You will then have the option to accept or refuse these cookies.'
  },

  manageCookies: {
    title: 'Managing cookies',
    intro: 'You can manage cookies through your web browser settings. Most browsers offer the ability to:',
    browsers: {
      chrome: 'Google Chrome: Settings > Privacy and security > Cookies and other site data',
      firefox: 'Mozilla Firefox: Settings > Privacy and security > Cookies and site data',
      safari: 'Safari: Preferences > Privacy > Cookies and website data',
      edge: 'Microsoft Edge: Settings > Cookies and site permissions'
    },
    warning: 'Please note: Disabling strictly necessary cookies may limit the functionality of our website.'
  },

  updates: {
    title: 'Changes to this cookie policy',
    text: 'We reserve the right to modify this Cookie Policy. Any changes will be published on this page. We recommend that you consult this policy regularly to stay informed of any changes.'
  },

  contact: {
    title: 'Contact',
    intro: 'Do you have questions about our Cookie Policy? Please contact us:'
  },

  moreInfo: {
    title: 'More information',
    intro: 'For more information about how we handle your data, please refer to:',
    privacyLink: 'Privacy Policy',
    termsLink: 'Terms of Service'
  }
};